<template>
    <div class="content">
        <!--
        <h1>HOROSKOP BERECHNEN</h1>
        <p>Hier können Sie sich kostenfrei Ihre persönlichen Horoskop-Daten berechnen lassen.</p>
        <div class="col-xs-12 col-sm-12 col-md-12 item-hint">
            Geben Sie einfach Ihre Geburts-Daten ein.<br>
            War zum Zeitpunkt Ihrer Geburt Sommerzeit, addieren Sie die Stunde(n) zu Ihrer Geburts-Zeit.<br>
            Kennen Sie Ihre genaue Geburts-Zeit nicht, tragen Sie bitte 12:00 Uhr ein.
        </div>
        <div class="form-group row">
            <div class="form-item suggest-rel col-md-6">
                <input
                    type="text"
                    id="PlaceOfBirthInput"
                    v-model="horoscope.PlaceOfBirth"
                    @input="getGoogleSuggestions()"
                    class="form-input"
                    :class="!horoscope.PlaceOfBirth || !horoscope.PlaceId ? 'form-error' : null"
                    :placeholder="dataPlaceholder.PlaceOfBirth">
                <div class="suggest-abs">
                    <div
                        class="suggest-item"
                        @click="selectSuggestion(item)"
                        v-for="(item, index) in googleSuggestions" :key="index">
                        {{ item.description }}
                    </div>
                </div>
            </div>
            <div class="form-item form-item-day col-md-6">
                <select
                    v-model="horoscope.DayOfBirth"
                    @change="saveHoroscopeData(true)"
                    :class="!horoscope.DayOfBirth ? 'form-error' : null">
                    <option v-for="option in dayOfBirth" :value="option.value" :key="option.value">
                        {{ option.text }}
                    </option>
                </select>
                <select
                    v-model="horoscope.MonthOfBirth"
                    @change="adjustDays()"
                    :class="!horoscope.MonthOfBirth ? 'form-error' : null">
                    <option v-for="option in monthOfBirth" :value="option.value" :key="option.value">
                        {{ option.text }}
                    </option>
                </select>
                <select
                    v-model="horoscope.YearOfBirth"
                    @change="adjustDays()"
                    :class="!horoscope.YearOfBirth ? 'form-error' : null">
                    <option v-for="option in yearOfBirth" :value="option.value" :key="option.value">
                        {{ option.text }}
                    </option>
                </select>
                <span class="form-label">&nbsp;Geburtsdatum</span>
            </div>
            <div class="form-item col-md-6">
                <select
                    v-model="horoscope.HourOfBirth"
                    @change="saveHoroscopeData(true)"
                    :class="!horoscope.HourOfBirth ? 'form-error' : null">
                    <option v-for="option in hourOfBirth" :value="option.value" :key="option.value">
                        {{ option.text }}
                    </option>
                </select>
                <select
                    v-model="horoscope.MinuteOfBirth"
                    @change="saveHoroscopeData(true)"
                    :class="!horoscope.MinuteOfBirth ? 'form-error' : null">
                    <option v-for="option in minuteOfBirth" :value="option.value" :key="option.value">
                        {{ option.text }}
                    </option>
                </select>
                <span class="form-label">&nbsp;Geburtszeit</span>
            </div>
        </div>
        <DisplayHoroscope
            v-if="showHoroscopeData"
            :ephemeridesData="ephemeridesData"
        ></DisplayHoroscope>
        <p class="to-shop">
            Ausführliche Informationen über Ihre astrologische Disposition finden Sie in unserem Shop.<br>
            Dort erhalten Sie
        </p>
        <p>
            <ul>
                <li>Persönlichkeits-Analysen</li>
                <li>Partner-Analysen</li>
                <li>Kinder-Analysen</li>
                <li>Geburts-Horoskopgrafiken</li>
                <li>Partner-Horoskopgrafiken</li>
                <li>Differenzierte Datenblätter zum Geburtshoroskop</li>
            </ul>
        </p>
        <button
            class="btn btn-success btn-to-shop"
            @click="toShop()">
            <i class="fas fa-shopping-bag"></i>Zum Shop
        </button>
        //-->
        Under construction...
    </div>
</template>

<script>
import DisplayHoroscope from '../components/DisplayHoroscope.vue';
import AutoComplete from '../components/AutoComplete.vue';
import siteConfig from '@/assets/js/mixins/siteConfig';
import JQuery from 'jquery';
let $ = JQuery;

export default {
    name: 'horoscope',
    mixins: [
        siteConfig
    ],
    components: {
        DisplayHoroscope,
        AutoComplete
    },
    props: {
        GoogleApiKey: {
            Type: String,
            required: true
        }
    },
    data() {
        return {
            horoscope: {
                PlaceOfBirth: null,
                PlaceId: null,
                PlaceCoords: null,
                DayOfBirth: null,
                MonthOfBirth: null,
                YearOfBirth: null,
                HourOfBirth: null,
                MinuteOfBirth: null,
                StoredPlaceOfBirth: '',
                StoredPlaceId: ''
            },
            dayOfBirth: [],
            monthOfBirth: [],
            yearOfBirth: [],
            hourOfBirth: [],
            minuteOfBirth: [],
            calcHoroscopeButtonDisabled: false,
            showHoroscopeData: false,
            ephemeridesData: null,
            nextDayDataObject: null,
            currentDayEphemerides: null,
            nextDayEphemerides: null,
            ephemeridesDate: '',
            googleSuggestions: null,
            placeId: null
        };
    },
    computed: {
        dataPlaceholder() {
            return {
                FirstName: 'Vorname',
                LastName: 'Nachname',
                PlaceOfBirth: 'Geburtsort',
                Gender: 'Geschlecht'
            };
        },
        inputClass() {
            return {
                FirstName: 'form-error'
            };
        }
    },
    methods: {
        getHoroscopeData() {
            let storedHoroscope = localStorage.getItem('horoscope');

            if (storedHoroscope) {
                this.horoscope = JSON.parse(storedHoroscope);
                this.showHoroscopeData = true;
            }

            this.getEphemerides();
        },
        
        /**
         * method for filling form selects
         */
        fillSelects() {
            let maxDays = this.getMaxDays();
            for (let i = 0; i <= maxDays; i++) {
                let text = (i < 10 ? '0' : '') + i;
                this.dayOfBirth.push({
                    value: i > 0 ? ((i < 10 ? '0' : '') + i) : null,
                    text: i > 0 ? text : '--'
                });
            }

            for (let i = 0; i <= 12; i++) {
                let text = (i < 10 ? '0' : '') + i;
                this.monthOfBirth.push({
                    value: i > 0 ? ((i < 10 ? '0' : '') + i) : null,
                    text: i > 0 ? text : '--'
                });
            }

            let currentYear = new Date().getFullYear();
            for (let i = currentYear + 1; i >= 1900; i--) {
                this.yearOfBirth.push({
                    value: i <= currentYear ? i : null,
                    text: i <= currentYear ? i : '--'
                });
            }

            for (let i = -1; i <= 23; i++) {
                let text = (i < 10 ? '0' : '') + i;
                this.hourOfBirth.push({
                    value: i >= 0 ? ((i < 10 ? '0' : '') + i) : null,
                    text: i >= 0 ? text : '--'
                });
            }

            for (let i = -1; i <= 59; i++) {
                let text = (i < 10 ? '0' : '') + i;
                this.minuteOfBirth.push({
                    value: i >= 0 ? ((i < 10 ? '0' : '') + i) : null,
                    text: i >= 0 ? text : '--'
                });
            }
        },

        getGoogleSuggestions() {
            if (this.horoscope.PlaceOfBirth !== this.horoscope.StoredPlaceOfBirth) {
                this.horoscope.StoredPlaceOfBirth = this.horoscope.PlaceOfBirth;
                this.saveHoroscopeData(true);

                let request = $.ajax({
                    url: siteConfig.ajaxUrl + 'places.php',
                    type: 'POST',
                    data: 'input=' + this.horoscope.PlaceOfBirth,
                    dataType: 'html'
                });

                const that = this;
                request.done(function(data) {
                    that.googleSuggestions = JSON.parse(data).predictions;
                    if (that.googleSuggestions.length) {
                        $('.suggest-abs').show();
                    } else {
                        $('.suggest-abs').hide();
                    }
                });

                request.fail(function() {
                    console.log('Some error occured');
                });
            }
        },

        selectSuggestion(item) {
            this.horoscope.PlaceOfBirth = item.description;
            this.horoscope.PlaceId = item.place_id;
            $('.suggest-abs').hide();
            this.googleSuggestions = null;
            $('#PlaceOfBirthInput').focus();
            this.saveHoroscopeData(true);
        },

        getMaxDays() {
            let month = parseInt(this.horoscope.MonthOfBirth);
            let year = parseInt(this.horoscope.YearOfBirth);

            const isLeapYear = this.leapYear(year);
            let februaryMax = isLeapYear ? 29 : 28;

            let maxDays = 31;
            if (month === 4 || month === 6 || month === 9 || month === 11) {
                maxDays = 30;
            } else if (month === 2) {
                maxDays = februaryMax;
            }

            return maxDays;
        },

        adjustDays() {
            let maxDays = this.getMaxDays();

            if (this.horoscope.DayOfBirth > maxDays) {
                this.horoscope.DayOfBirth = null;
            }

            delete this.dayOfBirth;
            this.dayOfBirth = [];
            for (let i = 0; i <= maxDays; i++) {
                let text = (i < 10 ? '0' : '') + i;
                this.dayOfBirth.push({
                    value: i > 0 ? ((i < 10 ? '0' : '') + i) : null,
                    text: i > 0 ? text : '--'
                });
            }

            this.saveHoroscopeData(true);
        },

        saveHoroscopeData(getEphemerides) {
            localStorage.horoscope = JSON.stringify(this.horoscope);

            if (getEphemerides === true) {
                this.getEphemerides();
            }
        },

        getEphemerides() {
            let horoscopeValid = this.horoscopeValidation();

            if (horoscopeValid) {
                if (this.ephemeridesDate !== this.horoscope.YearOfBirth + '_' + this.horoscope.MonthOfBirth) {
                    this.ephemeridesDate = this.horoscope.YearOfBirth + '_' + this.horoscope.MonthOfBirth;

                    const that = this;
                    let request = $.ajax({
                        url: siteConfig.ajaxUrl + 'ephemerides.php',
                        type: 'POST',
                        data: 'date=' + that.ephemeridesDate,
                        dataType: 'html'
                    });

                    request.done(function(data) {
                        that.currentDayEphemerides = data;
                        that.calcHoroscope();
                    });

                    request.fail(function() {
                        console.log('Some error occured');
                    });
                } else {
                    this.calcHoroscope();
                }
            } else {
                this.ephemeridesData = null;
            }
        },

        calcHoroscope() {
            const year = parseInt(this.horoscope.YearOfBirth);
            const month = parseInt(this.horoscope.MonthOfBirth);
            const day = parseInt(this.horoscope.DayOfBirth);

            const isLeapYear = this.leapYear(year);

            let februaryMax = isLeapYear ? 29 : 28;

            let nextDateDay = day + 1;
            let nextDateMonth = month;
            let nextDateYear = year;
            if (((month === 4 || month === 6 || month === 9 || month === 11) && day === 30) ||
                (month === 2 && day === februaryMax) ||
                day === 31
            ) {
                nextDateDay = 1;
                nextDateMonth = month + 1;
                if (month === 12) {
                    nextDateMonth = 1;
                    nextDateYear = year + 1;
                }
            }

            if (nextDateDay < 10) {
                nextDateDay = '0' + nextDateDay;
            }

            if (nextDateMonth < 10) {
                nextDateMonth = '0' + nextDateMonth;
            }

            if (parseInt(nextDateMonth) !== month) {
                let date = nextDateYear + '_' + nextDateMonth;
                let request = $.ajax({
                    url: siteConfig.ajaxUrl + 'ephemerides.php',
                    type: 'POST',
                    data: 'date=' + date,
                    dataType: 'html'
                });

                const that = this;
                request.done(function(data) {
                    that.nextDayEphemerides = data;
                    that.displayHoroscope(false);
                });

                request.fail(function() {
                    console.log('Some error occured');
                });
            } else {
                this.displayHoroscope(true);
            }
        },

        leapYear(year) {
            return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
        },

        displayHoroscope(sameFile) {
            let dataObject = JSON.parse(this.currentDayEphemerides);
            let i;
            for (i = 0; i < dataObject.length; i++) {
                if (dataObject[i].Date === this.horoscope.DayOfBirth + '.' + this.horoscope.MonthOfBirth + '.' + this.horoscope.YearOfBirth) {
                    this.ephemeridesData = dataObject[i];
                    break;
                }
            }

            if (sameFile === true) {
                this.nextDayDataObject = dataObject[i + 1];
            } else {
                this.nextDayDataObject = JSON.parse(this.nextDayEphemerides)[0];
            }

            this.getPlaceGeometry(this.horoscope.PlaceId);
        },

        getPlaceGeometry(placeId) {
            if (placeId !== this.horoscope.StoredPlaceId) {
                this.horoscope.StoredPlaceId = placeId;
                this.saveHoroscopeData(false);
                this.placeId = placeId;
                let request = $.ajax({
                    url: siteConfig.ajaxUrl + 'coords.php',
                    type: 'POST',
                    data: 'placeId=' + placeId,
                    dataType: 'html'
                });

                const that = this;
                request.done(function(data) {
                    let dataObject = JSON.parse(data);
                    that.horoscope.PlaceCoords = dataObject.result.geometry.location;
                    that.saveHoroscopeData(false);
                    that.printHoroscope();
                });

                request.fail(function() {
                    console.log('Some error occured');
                });
            } else {
                this.printHoroscope();
            }
        },

        printHoroscope() {
            let timezoneDiff = this.horoscope.PlaceCoords.lng / 15;

            Object.keys(this.ephemeridesData).forEach(item => {
                if (item !== 'Date') {
                    let currentSunDegree = parseInt(this.ephemeridesData[item].Grad.split('°')[0]);
                    let nextdaySunDegree = parseInt(this.nextDayDataObject[item].Grad.split('°')[0]);
                    let currentSunBowmin = parseInt(this.ephemeridesData[item].Grad.split('°')[1].substr(0, this.ephemeridesData[item].Grad.split('°')[1].length - 1));
                    let nextdaySunBowmin = parseInt(this.nextDayDataObject[item].Grad.split('°')[1].substr(0, this.nextDayDataObject[item].Grad.split('°')[1].length - 1));

                    let cBowmin = currentSunDegree * 60 + currentSunBowmin;
                    let nBowmin = nextdaySunDegree * 60 + nextdaySunBowmin;
                    let bDiff = nBowmin - cBowmin;

                    if (bDiff < 0) {
                        bDiff *= -1;
                    }

                    let minutesOfBirth = ((parseInt(this.horoscope.HourOfBirth) + timezoneDiff) * 60) + parseInt(this.horoscope.MinuteOfBirth);
                    let minutesQoutient = minutesOfBirth / 1440;

                    let superDiff = Math.round(bDiff * minutesQoutient);

                    let superExactlyBowmin = cBowmin + superDiff;

                    let superExactlySignDegree = parseInt(superExactlyBowmin / 60);
                    let superExactlySignBowmin = superExactlyBowmin % 60;

                    if (superExactlySignDegree > 30) {
                        superExactlySignDegree -= 30;
                        this.ephemeridesData[item].Zeichen = this.nextDayDataObject[item].Zeichen;
                    }
                    if (superExactlySignBowmin > 60) {
                        superExactlySignBowmin -= 60;
                    }
                    if (superExactlySignBowmin < 10) {
                        superExactlySignBowmin = '0' + superExactlySignBowmin;
                    }

                    this.ephemeridesData[item].Grad = superExactlySignDegree + '°' + superExactlySignBowmin + '\'';

                    if (this.ephemeridesData[item].Richtung) {
                        this.ephemeridesData[item].Richtung = 'rückläufig';
                    }
                }
            });

            this.showHoroscopeData = true;
        },

        /**
         * method for validating horoscope horoscope
         * @returns {boolean}
         */
        horoscopeValidation() {
            return this.horoscope.PlaceOfBirth &&
                this.horoscope.PlaceId &&
                this.horoscope.DayOfBirth &&
                this.horoscope.MonthOfBirth &&
                this.horoscope.YearOfBirth &&
                this.horoscope.HourOfBirth &&
                this.horoscope.MinuteOfBirth;
        },

        emitLogData(page, action) {
            this.$emit(
                'log-it',
                '{"page": "' + page + '", "action": "' + action + '"}'
            );
        },

        toShop() {
            this.emitLogData('horoscope', 'toShopButton');
            this.$router.push({ path: 'shop' });
        }
    },
    created() {
        this.getHoroscopeData();
        this.fillSelects();
    },
    mounted() {
        this.emitLogData('horoscope', 'visit');
    },
    beforeDestroy() {
        this.emitLogData('horoscope', 'leave');
    }
};
</script>

<style lang="scss" scoped>
    .content {
        position: relative;
    }
    .item-hint {
        color: gray;
        line-height: 1.2em;
        padding-left: 0 !important;
        margin: 15px 0 5px 0;
    }
    .fas {
        margin-top: -3px;
    }
    .form-group {
        width: 100%;
        margin-bottom: 20px !important;
    }
    .form-item {
        /* padding: 0 5px 0 0; */
        padding: 0;
    }
    .form-item input,
    .form-item select {
        border: 1px solid lightgray;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        margin-bottom: 5px;
        padding: 0 5px;
    }
    .form-item select {
        margin-right: 4px;
    }
    .form-item-day {
        padding: 0 5px;
    }
    .form-label {
        color: gray;
    }
    input {
        width: 100%;
    }
    input,
    select {
        height: 26px;
    }
    ::placeholder {
        color: lightgray;
    }
    .btn-to-checkout {
        margin: 40px 0;
    }
    .fas {
        margin-right: 10px;
    }
    .fa-crosshairs {
        margin-left: -5px;
        margin-right: 5px;
    }
    .notification-horoscope {
        left: 8px;
        bottom: 96px;
    }
    .to-shop {
        margin-top: 30px;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        padding: 35px 0 0 0;
    }
    .btn-to-shop {
        margin: 5px 0 50px;
    }
    .suggest-rel {
        position: relative;
    }
    .suggest-abs {
        position: absolute;
        top: 23px;
        left: 0;
        width: 100%;
        background: #FFFFFF;
        border-left: 1px solid lightgray;
        border-right: 1px solid lightgray;
        border-bottom: 1px solid lightgray;
        -webkit-border-radius: 0 0 4px 4px;
        -moz-border-radius: 0 0 4px 4px;
        border-radius: 0 0 4px 4px;
        padding: 2px 3px 3px 3px;
        z-index: 1;
        display: none;
    }
    .suggest-item {
        padding: 0 2px;
        cursor: pointer;
    }
    .suggest-item:hover {
        background: lightgrey;
    }
    @media only screen and (max-width: 600px) {
        input,
        select {
            height: 36px;
        }
        .form-item {
            padding: 0 5px 0 0;
        }
        .form-item-day {
            padding: 0;
        }
        .suggest-abs {
            top: 34px;
        }
        .suggest-item {
            padding: 5px 2px;
        }

    }
</style>
